<div class="ticket-summary-item"
     fxLayout="column"
     fxLayoutGap="0px">

  <div class="ticket-summary-item-header"
       fxFlex="100"
       fxLayout="row"
       fxLayoutGap="15px">

    <!--  EVent Image      -->
    <btx-event-image [count]="ticketCount" [imageSrc]="firstTicketItem.eventImage|secureImage"
                     class="test">
    </btx-event-image>

    <!--        -->
    <div class="product-detail" fxFill fxLayout="column">

      <!--            -->
      <btx-sub-title [matTooltip]="firstTicketItem.eventName.length>40 ? firstTicketItem.eventName:''"
                     [routerLink]="[performancePageLink]"
                     [title]="firstTicketItem.eventName |shorten:40"
                     class="event-name-title"></btx-sub-title>

      <!--            -->
      <btx-event-description *ngIf="firstTicketItem.eventCode !== 'YGIFK'" [startDate]="firstTicketItem?.performanceDate"
                             [venueCity]="firstTicketItem?.venueCity"
                             [venueName]="firstTicketItem?.venueName"></btx-event-description>

      <!--            -->
      <div class="product-detail-row product-action-buttons"
           fxLayout="row" [fxLayoutAlign]="isEventRulesVisible() ? 'space-between center' : 'flex-end center'">

        <div class="event-rules action-buttons" *ngIf="isEventRulesVisible()">
          <button (click)="showEventRules()"                  
                  class="event-rules"
                  mat-flat-button>
            <mat-icon aria-hidden="false">rule</mat-icon>
            {{ 'shared.labels.eventRules'|translate }}
          </button>
        </div>
        <div class="total-price-detail" fxLayout="column">
          <btx-product-price [value]="getShoppingItemsTotalPrice()"></btx-product-price>

          <!--                -->
          <div class="service-fee">
            <span class="service-fee-title">{{ 'shared.labels.serviceFee'|translate }}:</span>
            <btx-product-price
              [value]="getShoppingItemsTotalServicePrice()"
              class="service-fee-price">
            </btx-product-price>
          </div>

        </div>
      </div>
    </div>

  </div>
  <div class="ticket-summary-item-content"
       fxLayout="column"
       fxLayoutGap="15px">


    <!--        -->
    <div *ngIf="isLinksVisible() && firstTicketItem.eventCode !== 'YGIFK' " class="ticket-summary-actions">

      <!--            -->
      <mat-icon class="view-ticket-icon">subdirectory_arrow_right</mat-icon>

      <!--     Fatura     -->
      <a [href]="invoiceLink" class="view-ticket-button"
         target="_blank">
        <mat-icon>receipt</mat-icon>
        <span>{{ 'shared.labels.viewInvoice'|translate }}</span>
      </a>

      <!--       PDF Link     -->
      <a *ngIf="isHomePrint && !firstTicketItem.liveEvent && !tffEvent" [href]="digitalTicketLink"
         class="view-ticket-button"
         target="_blank">
        <mat-icon>receipt_long</mat-icon>
        <span>{{ 'shared.labels.seeDigitalTicket'|translate }}</span>
      </a>
    </div>

    <!--      Seat Number List      -->
    <div class="seat-number-list-wrapper" *ngIf="!firstTicketItem.liveEvent && firstTicketItem.eventCode !== 'YGIFK'">
      <!--            -->
      <h2 class="title">
        {{ (showOnlyDistributionCodes || distributionTokens.length) ? ('shared.labels.TicketInformation'|translate) : ('shared.labels.seatInfos'|translate:{count: ticketCount}) }}
      </h2>

      <!--            -->
      <ol class="seat-number-list"
          fxLayout="row wrap"
          fxLayoutGap="20px grid">

        <ng-container *ngIf="!showOnlyDistributionCodes; else distributionTokensOnly">
          <li *ngFor="let seatItem of seatNumberList"
              class="seat-number-item"
              fxFlex="25%"
              fxFlex.lt-md="33%"
              fxFlex.lt-sm="50%">

            <h2 class="sub-title">{{ seatItem.title|titlecase }}</h2>

            <!--                    -->
            <div class="seat-section">
              <span class="text-label">{{ 'shared.labels.section'|translate }}: </span>
              <span>{{ seatItem.section }}</span>
            </div>

            <!--                    -->
            <div *ngIf="seatItem.rowNo" class="seat-row-no">
              <span class="text-label">{{ 'shared.labels.row'|translate }}:</span>
              <span>{{ seatItem.rowNo }}</span>
            </div>
            <div *ngIf="seatItem.seatNo" class="seat-row-no">
              <span class="text-label">{{ 'shared.labels.seat'|translate }}:</span>
              <span>{{ seatItem.seatNo }}</span>
            </div>
            <div *ngIf="seatItem.distributionTokens?.length" class="seat-row-no">
              <span class="text-label">{{ 'shared.labels.CodeInformation'|translate }}: </span>
              <span>{{ seatItem.distributionTokens.join(', ') }}</span>
            </div>

          </li> 
        </ng-container>
        <ng-template #distributionTokensOnly>
          <li *ngIf="distributionTokens.length"
              class="seat-number-item"
              fxFlex="25%"
              fxFlex.lt-md="33%"
              fxFlex.lt-sm="50%">

            <div class="seat-row-no">
              <span class="text-label">{{ 'shared.labels.CodeInformation'|translate }}: </span>
              <span>{{ distributionTokens.join(', ') }}</span>
            </div>

          </li>
        </ng-template>

      </ol>
      <span>{{firstTicketItem.ticketNote }}</span> 
    </div>
    <div class="seat-number-list-wrapper" *ngIf="firstTicketItem.liveEvent">
      <!--            -->
      <h2 class="title">{{ 'shared.labels.liveEventInfos'|translate}}</h2>

      <!--            -->
      <ol class="seat-number-list"
          fxLayout="column">

          <li *ngFor="let token of liveEventTokens"
            class="seat-number-item"
            fxFlex="25%"
            fxFlex.lt-md="33%"
            fxFlex.lt-sm="50%">

            <span>{{ token }}</span>

          </li>
          <!--                    -->
          <div class="onlineLink">
            <a *ngIf="liveEventDistributionLink !== null && liveEventDistributionLink !== ''"
            [href]="liveEventDistributionLink"
            target="_blank"
            class="view-ticket-button"
            fxLayout="row" fxLayoutGap="5px"
          >
            <mat-icon>receipt_long</mat-icon>
            <span>{{ "account.labels.onlineLink" | translate }}</span>
            </a>
            <span>{{ firstTicketItem.ticketNote }}</span>
          </div>

          
      </ol>
    </div>
    <div class="seat-number-list-wrapper" *ngIf="firstTicketItem.eventCode == 'YGIFK'">
      <!--            -->
      <h2 class="title">{{ 'shared.labels.giftCardInfos'|translate}}</h2>
      <div fxLayout="column" fxLayoutGap="5px">
        <ol class="seat-number-list"
          fxLayout="row wrap"
          fxLayoutGap="20px grid">

        <li *ngFor="let item of eventTickets"
            class="seat-number-item"
            fxLayout="row"
            fxLayoutGap="5px"
            fxFlex="33%"
            fxFlex.lt-md="33%"
            fxFlex.lt-sm="50%">
            <span>{{item.priceCategoryName}}</span>

        </li>
        </ol>
        <span>{{firstTicketItem.ticketNote }}</span> 
          
      </div>
      
    </div>


<!--     
    <div class="onlineEvent" fxLayout="column" fxLayoutGap="10px" *ngIf="hasLiveToken() && showLiveEventContainer">
      <span *ngFor="let token of liveEventTokens">{{ "account.labels.onlineCode" | translate }}:
        <span>{{ token }}</span>
      </span>
    </div>

    <div class="onlineLink"  fxLayout="column" fxLayoutGap="10px" *ngIf="hasLiveEventLink() && showLiveEventContainer">
      <span>{{ firstTicketItem.ticketNote }}</span>
      <a
      [href]="liveEventDistributionLink"
      target="_blank"
      class="view-ticket-button"
      fxLayout="row" fxLayoutGap="5px"
    >
      <mat-icon>receipt_long</mat-icon>
      <span>{{ "account.labels.onlineLink" | translate }}</span>
    </a>
    </div> -->

    <!--   Upsell List     -->
    <div *ngIf="isEventUpsellVisible()" class="event-upsell-list-wrapper">
      <h2>{{ 'cart.labels.takenTogetherMobile'|translate:{value: totalUpsellCount} }}</h2>
      <div class="event-upsell-list">
        <div *ngFor="let upsellItem of eventUpsells" class="event-upsell-item">

          <div class="upsell-image-container">

            <!--                    -->
            <img [src]="upsellItem.upsellImage|secureImage:upsellImageBasePath"
                 alt="" class="upsell-thumb"/>

            <!--          -->
            <span [matBadge]="'x'+upsellItem.quantity"
                  class="upsell-quantity"
                  matBadgeColor="warn"></span>
          </div>

          <!--                    -->
          <div class="upsell-item-right">
            <h3>{{ upsellItem.upsellName }}</h3>
            <span class="upsell-price">{{ upsellItem.upsellTotalPrice|customCurrency }}</span>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
